import React from 'react';

import { useIntl } from 'react-intl';

import EmptyState from 'components/empty-state';
import { routes } from 'utils/routing';

import { Wrap } from './styled';

export const DeliveryMessageView = () => {
  const { formatMessage } = useIntl();

  return (
    <Wrap>
      <EmptyState
        header={formatMessage({ id: 'deliveryNoOffersMessage' })}
        linkText={formatMessage({ id: 'deliverySeeMenu' })}
        linkTo={routes.menu}
        subheader={formatMessage({ id: 'subheaderForDeliveryNoOffers' })}
      />
    </Wrap>
  );
};
